import React from 'react';
import { useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import { COLOR } from '@src/styles/color';
import {
  MAX_TOTAL_CHARACTERS,
  CHARACTER_LIMIT_BANNER_HEIGHT,
  AUTO_SAVE_STATUS,
} from '@src/constants/project';
import Typography from '@src/new-components/Typography';
import useIsOverCharacterLimit from '@src/hooks/useIsOverCharacterLimit';

const BANNER_STYLE = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: COLOR.functionalRed.default,
  height: CHARACTER_LIMIT_BANNER_HEIGHT,
  padding: '0 24px',
  flexShrink: 0,
  overflow: 'hidden',
};

// Map a `<b>` tag inside the i18n string to a real <b> element so messages can
// emphasize part of their text (e.g. "...do <b>dự án đã bị xoá</b>.").
const TRANS_COMPONENTS = { b: <b /> };

// Full-width red banner shown above the project content while auto-save is on.
// The deleted state (project removed on the Backend, error_code 1040) is
// terminal and takes priority over the recoverable over-limit message.
const AutoSaveBanner = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const isOverLimit = useIsOverCharacterLimit();
  const isDeleted = useSelector(
    (s) => s.project.autoSaveStatus === AUTO_SAVE_STATUS.DELETED,
  );

  const banner = (() => {
    if (isDeleted) return { i18nKey: 'autoSaveProjectDeletedBanner' };
    if (isOverLimit)
      return {
        i18nKey: 'autoSaveCharLimitBanner',
        values: {
          maxCharacters: MAX_TOTAL_CHARACTERS.toLocaleString(language),
        },
      };
    return null;
  })();

  if (!banner) return null;
  return (
    <div style={BANNER_STYLE}>
      <Typography variant="body-14-medium" color={COLOR.white} align="center">
        <Trans
          t={t}
          i18nKey={banner.i18nKey}
          values={banner.values}
          components={TRANS_COMPONENTS}
        />
      </Typography>
    </div>
  );
};

export default AutoSaveBanner;
